import { api } from './client';

export interface MateriaalProject {
  soId: number;
  soName: string;
  projectId: number | null;
  projectName: string;
  clientName: string;
  dateOrder: string;
  state: string;
  stageId: number | null;
  stageName: string | null;
  opgelijstDone: number;
  opgelijstTotal: number;
}

export interface MateriaalProjectStage {
  id: number;
  name: string;
}

export async function fetchMateriaalProjects(): Promise<MateriaalProject[]> {
  const res = await api<{ projects: MateriaalProject[] }>('/api/materiaal-projects');
  return res.projects;
}

export async function fetchMateriaalProjectStages(): Promise<MateriaalProjectStage[]> {
  const res = await api<{ stages: MateriaalProjectStage[] }>('/api/materiaal-projects/stages');
  return res.stages;
}

export async function updateMateriaalProjectStage(projectId: number, stageId: number): Promise<void> {
  await api(`/api/materiaal-projects/${projectId}/stage`, {
    method: 'PATCH',
    body: JSON.stringify({ stageId }),
  });
}
